import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";

const PreWithdrawForm = ({ onGenerateOtp, withdrawOtpConfig, onSubmit }) => {
  const [otp, setOtp] = useState("");

  return (
    <>
      <Form className="gatewayForm mt-3">
        <p
          style={{
            fontSize: "18px",
            fontWeight: 600,
            textAlign: "center",
          }}>
          Complete verification to withdraw
        </p>
        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName">
          <Form.Control
            type={"text"}
            placeholder={"Enter OTP"}
            name={"otp"}
            onChange={(e) => setOtp(e.target.value)}
          />
          <span className="focus-border">
            <i></i>
          </span>
        </Form.Group>
        <div className="d-flex flex-row gap-2">
          <Button
            onClick={() => onSubmit(otp)}
            disabled={
              withdrawOtpConfig?.otpSent == false || !otp || otp === ""
            }>
            {" "}
            Submit
          </Button>

          <Button
            onClick={onGenerateOtp}
            disabled={withdrawOtpConfig?.otpSent}
            className="mx-2">
            {withdrawOtpConfig?.isSendingOtp ? "Requesting..." : "Generate OTP"}
          </Button>
        </div>
      </Form>
    </>
  );
};
export default PreWithdrawForm;
